import { Button } from "antd";
import { useEffect, useState } from "react";
import { exitImpersonation, getImpersonation, queryImpersonationStatus } from "../../tools/impersonation";

// shown on every page while this tab is inside a dealer's panel via "ورود به عنوان"
export const ImpersonationBar = () => {
	const imp = getImpersonation();
	const [leaving, setLeaving] = useState(false);
	const [impersonator, setImpersonator] = useState(null);

	useEffect(() => {
		if (!imp) return;
		// server is the source of truth: a closed/expired session ends here too
		queryImpersonationStatus().then((res) => {
			if (res.status === 401 || (res.ok && res.data?.IsImpersonating === false)) exitImpersonation({ callServer: false });
			else if (res.ok) setImpersonator(res.data?.ImpersonatorUsername);
		});
		const msLeft = Date.parse(imp.expiresAt) - Date.now();
		if (Number.isNaN(msLeft)) return;
		const timer = setTimeout(() => exitImpersonation({ callServer: false }), Math.max(0, msLeft));
		return () => clearTimeout(timer);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (!imp) return null;

	const leave = async () => {
		setLeaving(true);
		await exitImpersonation();
	};

	return (
		<div className="impersonation-bar" role="status">
			<span>
				در حال ورود به‌عنوان <strong dir="ltr">{imp.dealerUsername}</strong> هستید
				{impersonator && (
					<>
						{" "}
						(توسط <span dir="ltr">{impersonator}</span>)
					</>
				)}
			</span>
			<Button size="small" loading={leaving} onClick={leave}>
				بازگشت به حساب کاربری
			</Button>
		</div>
	);
};
